import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto 1fr 1fr;
  grid-gap: 5px;
  width: 100%;
`;
